(function(app) {

    app.provider("marketingTrackerApi",
    [
        function() {
            this.$get = [
                "portalApiGateway", function(portalApiGateway) {
                    var service = {};

                    service.getToken = function() {
                        return portalApiGateway.get("/MarketingTracker/Token");
                    }

                    return service;
                }
            ];
        }
    ]);
})(window.app);